import WebpagePreview, { PreviewCardProps } from "./webpage-preview";
import YoutubePreview from "./youtube-preview";

/**
 * Renders a link preview as whichever card its provider calls for.
 *
 *     LinkPreview
 *     ├── webpage   → WebpagePreview
 *     └── youtube   → YoutubePreview
 *
 * Posts only ever render this; they neither know nor care which provider
 * resolved the URL. `compact` and `onDismiss` are for the composer.
 */
const LinkPreviewCard = (props: PreviewCardProps) => {
  switch (props.preview.type) {
    case "youtube":
      return <YoutubePreview {...props} />;
    case "webpage":
    default:
      return <WebpagePreview {...props} />;
  }
};

export default LinkPreviewCard;
